/**
 * Row-based representations of FaultLog parallel arrays
 * Used for displaying and editing customer/device data in table format
 */

import { Utils } from "../utils/Utils";

export interface CustomerRow {
  flag: string;
  name: string;
  city: string;
  stateCode: string;
  shipTo: string;
  demandType: string;
  postCode: string;
  terminal: string;
  product: string;
  numOfDeliveries?: number;
  vesselId: string;
}

export interface DeviceRow {
  id: string;
  type: string;
}

/**
 * Helper to create an empty customer row
 */
export const createEmptyCustomerRow = (): CustomerRow => ({
  flag: "",
  name: "",
  city: "",
  stateCode: "",
  shipTo: "",
  demandType: "",
  postCode: "",
  terminal: "",
  product: "",
  numOfDeliveries: undefined,
  vesselId: "",
});

/**
 * Helper to create an empty device row
 */
export const createEmptyDeviceRow = (): DeviceRow => ({
  id: "",
  type: "",
});

/**
 * Check if a customer row is completely empty (all fields empty or whitespace)
 */
export const isCustomerRowEmpty = (row: CustomerRow): boolean => {
  return (
    Utils.isEmpty(row.flag) &&
    Utils.isEmpty(row.name) &&
    Utils.isEmpty(row.city) &&
    Utils.isEmpty(row.postCode) &&
    Utils.isEmpty(row.stateCode) &&
    Utils.isEmpty(row.shipTo) &&
    Utils.isEmpty(row.demandType) &&
    Utils.isEmpty(row.terminal) &&
    Utils.isEmpty(row.product) &&
    Utils.isEmpty(row.numOfDeliveries) &&
    Utils.isEmpty(row.vesselId)
  );
};

/**
 * Check if a device row is completely empty
 */
export const isDeviceRowEmpty = (row: DeviceRow): boolean => {
  return !row.id?.trim() && !row.type?.trim();
};
